import parcelTruck from 'assets/img/parcel-truck.svg'
import oneHalfTonPickup from 'assets/img/1-2-ton-pickup.svg'
import threeQuartersTonPickup from 'assets/img/3-4-ton-pickup.svg'
import oneTonPickup from 'assets/img/1-ton-pickup.svg'
import pickupWRack from 'assets/img/pickup-w-rack.svg'
import cargoVan from 'assets/img/cargo-van.svg'
import utilityTrlr from 'assets/img/utility-trlr.svg'
import deckTrlr from 'assets/img/deck-trlr-no-ramps.svg'
import equipTrlrSmoothRampsOrTilt from 'assets/img/equip-trlr-smooth-ramps-or-tilt.svg'
import equipTrlrtGuidedRamps from 'assets/img/equip-trlr-guided-ramps.svg'
import mastercard from 'assets/img/mastercard.svg'
import visa from 'assets/img/visa.svg'
import americanExpress from 'assets/img/american-express.svg'
import discover from 'assets/img/discover.svg'
import diners from 'assets/img/diners.svg'
import jcb from 'assets/img/jcb.svg'
import unionpay from 'assets/img/unionpay.svg'
import notificationTruck from 'assets/img/notification-truck.svg'

export const mockVehicles = [
  {
    id: '1',
    name: 'Parcel Truck',
    description: '',
    maxPayload: '200 lbs',
    estimatedPrice: '$375',
    image: parcelTruck,
  },
  {
    id: '2',
    name: '1/2 Ton Pickup',
    description: '',
    maxPayload: '1,500 lbs',
    estimatedPrice: '$375',
    image: oneHalfTonPickup,
  },
  {
    id: '3',
    name: '3/4 Ton Pickup',
    description: '',
    maxPayload: '3,000 lbs',
    estimatedPrice: '$375',
    image: threeQuartersTonPickup,
  },
  {
    id: '4',
    name: '1 Ton Pickup',
    description: '',
    maxPayload: '4,500 lbs',
    estimatedPrice: '$375',
    image: oneTonPickup,
  },
  {
    id: '5',
    name: 'Pickup w/rack',
    description: '',
    maxPayload: '850 lbs',
    estimatedPrice: '$375',
    image: pickupWRack,
  },
  {
    id: '6',
    name: 'Cargo Van',
    description: '',
    maxPayload: '1,500 lbs',
    estimatedPrice: '$375',
    image: cargoVan,
  },
  {
    id: '7',
    name: 'Utility Trlr',
    description: '',
    maxPayload: '4,500 lbs',
    estimatedPrice: '$375',
    image: utilityTrlr,
  },
  {
    id: '8',
    name: 'Deck Trlr',
    description: '(No Ramps)',
    maxPayload: '9,000 lbs',
    estimatedPrice: '$375',
    image: deckTrlr,
  },
  {
    id: '9',
    name: 'Equip Trlr',
    description: '(Smooth Ramps or Tilt)',
    maxPayload: '10,000 lbs',
    estimatedPrice: '$375',
    image: equipTrlrSmoothRampsOrTilt,
  },
  {
    id: '10',
    name: 'Equip Trlr',
    description: '(Guided Ramps)',
    maxPayload: '10,000 lbs',
    estimatedPrice: '$375',
    image: equipTrlrtGuidedRamps,
  },
]

export const countLoads = [
  {status: 'hauler-not-assigned', count: 1, statusText: 'Hauler Not Assigned'},
  {status: 'hauler-assigned', count: 2, statusText: 'Hauler Assigned'},
  {status: 'enroute-to-pickup', count: 1, statusText: 'Enroute To Pickup'},
  {status: 'enroute-to-delivery', count: 1, statusText: 'Enroute To Delivery'},
]

export const mockOpenLoads = [
  {
    id: 0,
    name: 'NEW L-097273925',
    status: 'hauler-not-assigned',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: undefined,
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '1.500',
    },
    pickupDate: '20 Jan 2025',
    pickupTime: '11:30 PM',
    route: {
      pickup: {
        lat: 33.4681595,
        lng: -112.1128711,
        name: '1313 N 25th Ave, Phoenix, AZ 85009, United States',
      },
      destination: {
        lat: 33.4330947,
        lng: -112.0619801,
        name: '1805 E Sky Harbor Cir S, Phoenix, AZ 85034, United States',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
  {
    id: 1,
    name: 'MID L-097273925',
    status: 'hauler-not-assigned',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: undefined,
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '1.500',
    },
    pickupDate: '20 Jan 2025',
    pickupTime: '11:30 PM',
    route: {
      pickup: {
        lat: 34.0489,
        lng: -111.0937,
        name: 'Arizona',
      },
      destination: {
        lat: 32.7767,
        lng: -96.797,
        name: 'Dallas',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
  {
    id: 2,
    name: 'NAME L-097273925',
    status: 'hauler-not-assigned',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: undefined,
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '1.500',
    },
    pickupDate: '20 Jan 2025',
    pickupTime: '11:30 PM',
    route: {
      pickup: {
        lat: 37.7749,
        lng: -122.4194,
        name: 'San Francisco',
      },
      destination: {
        lat: 36.7783,
        lng: -119.4179,
        name: 'California',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [
        {
          companyName: 'Company 2',
          userName: 'Jane',
          phone: '325 123 4511',
        },
      ],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
  {
    id: 3,
    name: 'NAME L-097273925',
    status: 'hauler-not-assigned',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: undefined,
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '1.500',
    },
    pickupDate: '20 Jan 2025',
    pickupTime: '11:30 PM',
    route: {
      pickup: {
        lat: 40.7128,
        lng: -74.006,
        name: 'New York',
      },
      destination: {
        lat: 41.8781,
        lng: -87.6298,
        name: 'Chicago',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [
        {
          companyName: 'Company 2',
          userName: 'Jane',
          phone: '325 123 4511',
        },
      ],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
]

export const mockAssignedLoads = [
  {
    id: 1,
    name: '2-TY727MNB Y-342423 423423 ',
    status: 'hauler-assigned',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: 'John Johnson',
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '1.500',
    },
    pickupDate: '20 Jan 2025',
    pickupTime: '11:30 PM',
    route: {
      pickup: {
        lat: 48.8566,
        lng: 2.3522,
        name: 'Paris',
      },
      waypoints: [],
      destination: {
        lat: 51.5074,
        lng: -0.1278,
        name: 'London',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [
        {
          companyName: 'Company 2',
          userName: 'Jane',
          phone: '325 123 4511',
        },
        {
          companyName: 'Company 3',
          userName: 'John E',
          phone: '225 123 4232',
        },
      ],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
  {
    id: 2,
    name: '2-TY727MNB Y-342423 423423 ',
    status: 'hauler-assigned',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: 'Jim',
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '2.500',
    },
    pickupDate: '30 Jan 2025',
    pickupTime: '10:30 PM',
    route: {
      pickup: {
        lat: 40.4168,
        lng: -3.7038,
        name: 'Madrid',
      },
      //waypoints: [{lat: 41.6488, lng: -0.8891, name: 'Zaragoza'}],
      destination: {
        lat: 41.3851,
        lng: 2.1734,
        name: 'Barcelona',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [
        {
          companyName: 'Company 2',
          userName: 'Jane',
          phone: '325 123 4511',
        },
        {
          companyName: 'Company 3',
          userName: 'John E',
          phone: '225 123 4232',
        },
      ],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
  {
    id: 3,
    name: '2-TY727MNB Y-342423 423423 ',
    status: 'hauler-assigned',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: 'Jim',
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '2.500',
    },
    pickupDate: '30 Jan 2025',
    pickupTime: '10:30 PM',
    route: {
      pickup: {
        lat: 41.8967,
        lng: 12.4822,
        name: 'Rome',
      },
      //waypoints: [{lat: 41.6488, lng: -0.8891, name: 'Zaragoza'}],
      destination: {
        lat: 44.4949,
        lng: 11.3426,
        name: 'Bologna',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [
        {
          companyName: 'Company 2',
          userName: 'Jane',
          phone: '325 123 4511',
        },
        {
          companyName: 'Company 3',
          userName: 'John E',
          phone: '225 123 4232',
        },
      ],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
]

export const mockEnrouteToPickupLoads = [
  {
    id: 1,
    name: 'II K-097273925',
    status: 'enroute-to-pickup',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: 'John Johnson',
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '1.500',
    },
    pickupDate: '20 Jan 2025',
    pickupTime: '11:30 PM',
    route: {
      pickup: {
        lat: 40.7128,
        lng: -74.006,
        name: 'New York',
      },
      waypoints: [{lat: 47.6062, lng: -122.3321, name: 'Seattle'}],
      destination: {
        lat: 41.8781,
        lng: -87.6298,
        name: 'Chicago',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [
        {
          companyName: 'Company 2',
          userName: 'Jane',
          phone: '325 123 4511',
        },
      ],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
]

export const mockEnrouteToDeliveryLoads = [
  {
    id: 1,
    name: 'LARGE 12345',
    status: 'enroute-to-delivery',
    createdTimestamp: '14 Jan 25',
    hauler: {
      name: 'John Johnson',
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '1.500',
    },
    pickupDate: '20 Jan 2025',
    pickupTime: '11:30 PM',
    route: {
      pickup: {
        lat: 40.7128,
        lng: -74.006,
        name: 'New York',
      },
      waypoints: [{lat: 47.6062, lng: -122.3321, name: 'Seattle'}],
      destination: {
        lat: 41.8781,
        lng: -87.6298,
        name: 'Chicago',
      },
    },
    contactDetails: {
      pickup: {
        companyName: 'Company 1',
        userName: 'Jim Smith',
        phone: '555 123 4567',
      },
      waypoints: [
        {
          companyName: 'Company 2',
          userName: 'Jane',
          phone: '325 123 4511',
        },
      ],
      destination: {
        companyName: 'Company 4',
        userName: 'Lily',
        phone: '335 123 4232',
      },
    },
  },
]

export const mockOrder = {
  id: 1,
  name: '2-TY727MNB',
  status: 'hauler-assigned',
  createdTimestamp: '14 Jan 25',
  hauler: {
    name: 'John Johnson',
  },
  trackingUrl: 'www.fero.com',
  tracking: [
    {description: 'Job completed', createdTimestamp: '8.56 AM, Feb 05'},
    {description: 'Unloading Completed', createdTimestamp: '8.56 AM, Feb 05'},
    {description: 'Unloading', createdTimestamp: '8.56 AM, Feb 05'},
    {
      description: 'Waiting Time At Delivery',
      createdTimestamp: '8.56 AM, Feb 05',
    },
    {
      description: 'At Delivery Location',
      createdTimestamp: '8.56 AM, Feb 05',
    },
    {
      description: 'On The Way To Delivery',
      createdTimestamp: '8.56 AM, Feb 05',
    },
    {description: 'Loading Completed', createdTimestamp: '8.56 AM, Feb 05'},
    {description: 'Loading', createdTimestamp: '8.56 AM, Feb 05'},
    {
      description: 'Waiting Time At Pickup',
      createdTimestamp: '8.56 AM, Feb 05',
    },
    {description: 'At Pickup', createdTimestamp: '8.56 AM, Feb 05'},
    {
      description: 'On The Way To Pickup',
      createdTimestamp: '8.56 AM, Feb 05',
    },
    {description: 'Hauler Assigned', createdTimestamp: '8.56 AM, Feb 05'},
    {description: 'New', createdTimestamp: '8.56 AM, Feb 05'},
  ],
  vehicle: {
    id: 1,
    name: 'Cargo Van',
    maxLoad: '1.500',
  },
  pickupDate: '20 Jan 2025',
  pickupTime: '11:30 PM',
  route: {
    pickup: {
      lat: 34.0489,
      lng: -111.0937,
      name: 'Arizona',
    },
    destination: {
      lat: 32.7767,
      lng: -96.797,
      name: 'Dallas',
    },
  },
  contactDetails: {
    pickup: {
      companyName: 'Company 1',
      userName: 'Jim Smith',
      phone: '555 123 4567',
    },
    waypoints: [
      {
        companyName: 'Company 2',
        userName: 'Jane',
        phone: '325 123 4511',
      },
      {
        companyName: 'Company 3',
        userName: 'John E',
        phone: '225 123 4232',
      },
    ],
    destination: {
      companyName: 'Company 4',
      userName: 'Lily',
      phone: '335 123 4232',
    },
  },
  billing: {
    name: 'John Doe',
    address: 'Oak Street 123, California, US',
    phone: '313 423 34334',
  },
  payment: {
    cardEnding: '1234',
    price: '375.00',
  },
  load: {
    commodityType: 'part',
    couplerType: {id: 1, name: 'pintle-hitch'},
    description: 'Lorem ipsum',
    weight: 500,
    assistAgreement: true,
    twic: true,
    spaceRequired: 'Option 1',
  },
  pop: [
    'https://www.chevrolet.ca/content/dam/chevrolet/na/canada/english/index/trucks/2024-colorado/segment-page/2024-colorado-segment.png',
    'https://www.dat.com/wp-content/uploads/2020/12/adobestock_38480065-1200x628-3.webp',
    'https://www.towjettruck.com/images/towjet-tow-truck_1.jpg',
    'https://professionalpickup.com/wp-content/uploads/2023/05/Kia-Pickup-Render-Kleber-Silva-2023-Professional-Pickup-Hero.jpg',
  ],
  documents: [
    {filename: 'Document.pdf', ext: '.pdf', url: 'www.document.com/pdf'},
    {filename: 'Instructions.docx', ext: '.docx', url: 'www.document.com/docx'},
    {filename: 'Preview.jpg', ext: '.jpg', url: 'www.document.com/jpg'},
  ],
  notesForHauler: 'These are notes for hauler',
  bolPo: '12321423432',
}

export const mockContacts = [
  {
    id: 1,
    contactType: 'business',
    companyName: 'FastTrack Logistics Ltd Company',
    location: [
      {id: 1, address: 'Chicago HQ: 123 Wacker Street Adress Department'},
      {id: 2, address: 'New York HQ: 555 Street'},
      {id: 3, address: 'Seattle'},
      {id: 4, address: 'Seattle'},
      {id: 5, address: 'Seattle'},
      {id: 6, address: 'Seattle'},
      {id: 7, address: 'Seattle'},
      {id: 8, address: 'Seattle'},
      {id: 9, address: 'Seattle'},
      {id: 10, address: 'Seattle'},
      {id: 11, address: 'Seattle'},
      {id: 12, address: 'Seattle'},
    ],
    email: '',
    phone: '+7770002221222222',
  },
  {
    id: 2,
    contactType: 'individual',
    companyName: 'BlueTech Innovations',
    location: [{id: 1, address: 'Chicago HQ: 123 Wacker'}],
    email: 'email@address.com',
    phone: '',
  },
  {
    id: 3,
    contactType: 'individual',
    companyName: 'GreenTech',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 4,
    contactType: 'business',
    companyName: 'FastTrack Logistics',
    location: [{id: 1, address: 'Chicago HQ: 123 Wacker'}],

    email: '',
    phone: '+777000222',
  },
  {
    id: 5,
    contactType: 'individual',
    companyName: 'BlueTech Innovations',
    location: [{id: 1, address: 'Chicago HQ: 123 Wacker'}],
    email: 'email@address.com',
    phone: '',
  },
  {
    id: 6,
    contactType: 'individual',
    companyName: 'GreenTech',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 7,
    contactType: 'business',
    companyName: 'FastTrack Logistics',
    location: [
      {id: 1, address: 'Chicago HQ: 123 Wacker'},
      {id: 1, address: 'New York HQ: 555 Street'},
    ],
    email: '',
    phone: '+777000222',
  },
  {
    id: 8,
    contactType: 'individual',
    companyName: 'BlueTech Innovations',
    location: [{id: 1, address: 'Chicago HQ: 123 Wacker'}],
    email: 'email@address.com',
    phone: '',
  },
  {
    id: 9,
    contactType: 'individual',
    companyName: 'GreenTech',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 10,
    contactType: 'business',
    companyName: 'FastTrack Logistics',
    location: [
      {id: 1, address: 'Chicago HQ: 123 Wacker'},
      {id: 1, address: 'New York HQ: 555 Street'},
    ],
    email: '',
    phone: '+777000222',
  },
  {
    id: 11,
    contactType: 'individual',
    companyName: 'BlueTech Innovations',
    location: [{id: 1, address: 'Chicago HQ: 123 Wacker'}],
    email: 'email@address.com',
    phone: '',
  },
  {
    id: 12,
    contactType: 'individual',
    companyName: 'GreenTech',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 13,
    contactType: 'business',
    companyName: 'FastTrack Logistics',
    location: [
      {id: 1, address: 'Chicago HQ: 123 Wacker'},
      {id: 1, address: 'New York HQ: 555 Street'},
    ],
    email: '',
    phone: '+777000222',
  },
  {
    id: 14,
    contactType: 'individual',
    companyName: 'BlueTech Innovations',
    location: [{id: 1, address: 'Chicago HQ: 123 Wacker'}],
    email: 'email@address.com',
    phone: '',
  },
  {
    id: 15,
    contactType: 'individual',
    companyName: 'GreenTech',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 16,
    contactType: 'business',
    companyName: 'FastTrack Logistics',
    location: [
      {id: 1, address: 'Chicago HQ: 123 Wacker'},
      {id: 1, address: 'New York HQ: 555 Street'},
    ],
    email: '',
    phone: '+777000222',
  },
  {
    id: 17,
    contactType: 'individual',
    companyName: 'BlueTech Innovations',
    location: [{id: 1, address: 'Chicago HQ: 123 Wacker'}],
    email: 'email@address.com',
    phone: '',
  },
  {
    id: 18,
    contactType: 'individual',
    companyName: 'GreenTech',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 19,
    contactType: 'business',
    companyName: 'FastTrack Logistics',
    location: [
      {id: 1, address: 'Chicago HQ: 123 Wacker'},
      {id: 1, address: 'New York HQ: 555 Street'},
    ],
    email: '',
    phone: '+777000222',
  },
  {
    id: 20,
    contactType: 'individual',
    companyName: 'BlueTech Innovations',
    location: [{id: 1, address: 'Chicago HQ: 123 Wacker'}],
    email: 'email@address.com',
    phone: '',
  },
  {
    id: 21,
    contactType: 'individual',
    companyName: 'GreenTech',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 22,
    contactType: 'individual',
    companyName: 'Novio',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 22,
    contactType: 'individual',
    companyName: 'Novio',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 22,
    contactType: 'individual',
    companyName: 'Novio',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 22,
    contactType: 'individual',
    companyName: 'Novio',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 22,
    contactType: 'individual',
    companyName: 'Novio',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
  {
    id: 22,
    contactType: 'individual',
    companyName: 'Novio',
    location: [],
    email: 'email@address.com',
    phone: '+907000231',
  },
]

export const mockContact = {
  id: 22,
  contactType: 'individual',
  companyName: 'Novio',
  branches: 32,
  location: [
    {
      id: 1,
      address: 'Chicago HQ: 123 Wacker',
      contact: {
        fullName: 'Jim Smith',
        phone: '(555) 312 - 423423',
      },
      shippingDetails: {
        fee: 109.9,
        note: 'Lorem ipsum',
      },
      shippingHours: [
        {day: 'monday', from: '08:00', until: '16:00'},
        {day: 'tuesday', from: '09:00', until: '15:00'},
      ],
    },
    {id: 2, address: 'New York'},
    {id: 3, address: 'New Jersey'},
    {id: 4, address: 'Columbia'},
  ],
  email: 'email@address.com',
  phone: '+907000231',
}

export const mockCreditCards = [
  {
    id: 1,
    image: visa,
    endingIn: '1234',
    title: 'Mastercard',
    type: 'mastercard',
    expiryDate: '07/28',
  },
  {
    id: 2,
    image: mastercard,
    endingIn: '1234',
    title: 'Mastercard',
    type: 'mastercard',
    expiryDate: '07/28',
  },
]

export const mockTransactions = [
  {
    id: 1,
    date: '2021-11-12',
    time: '11:30 PM',
    type: 'debit',
    amount: 100,
    currency: 'USD',
    status: 'completed',
    description: 'Wallet Recharged',
    cardId: 1,
    cardEnding: '1234',
  },
  {
    id: 2,
    date: '2022-11-12',
    time: '12:30 PM',
    type: 'credit',
    amount: 4000,
    currency: 'USD',
    status: 'completed',
    description: 'Wallet Recharged',
    cardId: 2,
    cardEnding: '2234',
  },
]

export const mockPastOrders = [
  {
    id: 1,
    masterOrderId: 1,
    pickupAddress: {
      address: '123 Wacker Street Adress Department',
      city: 'Chicago',
      state: 'IL',
      zip: '60606',
      country: 'USA',
      contactName: 'Jim Smith',
      phone: '555 123 4567',
    },
    deliveryDetails: {
      bookedOn: '02/26/25',
      pickupTime: '02/26/25',
    },
    deliveryAddress: {
      address: '456 Oak Street Adress',
      city: 'Nevada',
      state: 'NE',
      zip: '60606',
      country: 'USA',
      contactName: 'Jim Smith',
      phone: '555 123 4567',
    },
    vehicle: {
      id: 1,
      name: 'Cargo Van',
      maxLoad: '1.500',
    },
    status: 'completed',
  },
]

export const mockCanceledOrders = []

export const mockNotifications = [
  {
    id: 1,
    image: notificationTruck,
    title: 'Booking Confirmation',
    text: 'Your booking #12345 has been successfully confirmed',
    isRead: false,
  },
  {
    id: 1,
    image: notificationTruck,
    title: 'Booking Confirmation',
    text: 'Your booking #12345 has been successfully confirmed',
    isRead: true,
  },
]
